<template>
  <svg xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 50 50" xml:space="preserve">
    <path style="fill: #e5231b" d="M25 32.04c-7.18 0-13.02-5.84-13.02-13.02S17.82 6 25 6s13.02 5.84 13.02 13.02S32.18 32.04 25 32.04zm0-24.59c-6.38 0-11.57 5.19-11.57 11.57S18.62 30.59 25 30.59s11.57-5.19 11.57-11.57S31.38 7.45 25 7.45z"/>
    <path style="fill: #e5231b" class="st1" d="M25 49c-.21 0-.4-.09-.54-.24C12.76 35.81 7.1 24.91 7.62 16.36c.27-4.35 2.12-8.03 5.5-10.96 6.77-5.87 16.99-5.87 23.76 0 3.38 2.93 5.23 6.62 5.5 10.96.52 8.55-5.14 19.45-16.84 32.4-.14.15-.33.24-.54.24zm0-46.55c-3.91 0-7.81 1.35-10.93 4.05-3.07 2.66-4.76 6.01-5 9.95-.49 8.02 4.87 18.36 15.93 30.74 11.06-12.38 16.42-22.72 15.93-30.73-.24-3.94-1.92-7.29-5-9.95C32.82 3.8 28.91 2.45 25 2.45z"/>
  </svg>
</template>

<script>
export default {
  name: 'IconMapMarkerOrange',
}
</script>
